import { Tabs } from '@chakra-ui/react';
import ContractInfo from '@features/positions/hedgePositions/ContractInfo';
import CounterpartyTable from '@features/positions/hedgePositions/CounterpartyTable';
import { allContractSellers, Contract, ContractSeller } from 'helpers/fakeData';
import { LuInfo, LuShoppingCart } from 'react-icons/lu';

interface Props {
  contract: Contract;
}
type TabKey = 'ai-summary' | 'counterparties' | 'details';
type TabItem = {
  key: TabKey;
  label: string;
  icon?: React.ReactNode;
  component: React.ReactNode;
};

const getTabItems = (contract: Contract, counterparties: ContractSeller[]): TabItem[] => {
  const contractPosition = contract.position;
  if (contractPosition == null) {
    return [];
  }

  return [
    {
      key: 'details',
      label: 'Details',
      icon: <LuInfo />,
      component: <ContractInfo contract={contract} />,
    },
    {
      key: 'counterparties',
      label: contractPosition === 'BUYER' ? 'Sellers' : 'Buyers',
      icon: <LuShoppingCart />,
      component: <CounterpartyTable counterparties={counterparties} />,
    },
  ];
};

const ContractDetail: React.FC<Props> = ({ contract }) => {
  const tabItems = getTabItems(contract, allContractSellers);

  if (tabItems.length === 0) {
    return null;
  }

  return (
    <Tabs.Root defaultValue={tabItems[0].key} variant="subtle" size="sm">
      <Tabs.List>
        {tabItems.map((item) => (
          <Tabs.Trigger
            key={item.key}
            value={item.key}
            _selected={{
              bg: 'surface.accent',
            }}
          >
            {item.icon}
            {item.label}
          </Tabs.Trigger>
        ))}
        <Tabs.Indicator />
      </Tabs.List>
      {tabItems.map((item) => (
        <Tabs.Content key={item.key} value={item.key}>
          {item.component}
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
};

export default ContractDetail;
